import React from "react";
import "./SchoolPartnership.css";
import card1 from "../../assetsS/images/imagecard1.png";
import card2 from "../../assetsS/images/imagecard2.png";
import { FaArrowRight } from "react-icons/fa";

const Gallery = () => {
  const features = [
    {
      image: card2,
      title: "Chapter Wise Testing Practice",
      description:
        "SARASU enables schools and coaching institutes to align NEET test practice with their curriculum and timetable, helping educators evaluate and improve student performance systematically.",
    },
    {
      image: card1,
      title: "NEET Test Marathon Practice",
      description:
        "Students gain access to unlimited questions within a timed session, encouraging speed, accuracy, stamina, and real exam readiness through continuous practice.",
    },
  ];

  return (
    <section
      className="py-5"
      style={{
        background:
          "linear-gradient(180deg, #ffffff 0%, #f8fafc 100%)",
      }}
    >
      <div className="container">
        <div className="text-center mb-5">
          <span
            className="badge px-3 py-2 mb-3"
            style={{
              background: "#e8f5e9",
              color: "#2e7d32",
              fontSize: "0.9rem",
            }}
          >
            Smart Learning Features
          </span>

          <h2
            className="fw-bold"
            style={{
              fontSize: "clamp(2rem, 4vw, 3rem)",
              color: "#0f172a",
            }}
          >
            Advanced NEET Practice Tools
          </h2>

          <p
            className="text-muted mx-auto mt-3"
            style={{
              maxWidth: "700px",
              lineHeight: "1.8",
            }}
          >
            Empower students with structured practice, performance tracking,
            and exam-focused learning experiences.
          </p>
        </div>

        <div className="row g-4">
          {features.map((item, index) => (
            <div className="col-lg-6" key={index}>
              <div
                className="card border-0 h-100 shadow-sm feature-card"
                style={{
                  borderRadius: "24px",
                  overflow: "hidden",
                  transition: "all .35s ease",
                }}
              >
                <div
                  style={{
                    background: "#f8fafc",
                    padding: "30px",
                    textAlign: "center",
                  }}
                >
                  <img
                    src={item.image}
                    alt={item.title}
                    className="img-fluid"
                    style={{
                      maxHeight: "260px",
                      objectFit: "contain",
                    }}
                  />
                </div>

                <div className="card-body p-4">
                  <h4
                    className="fw-bold mb-3"
                    style={{
                      color: "#0f172a",
                    }}
                  >
                    {item.title}
                  </h4>

                  <p
                    className="text-muted mb-4"
                    style={{
                      lineHeight: "1.8",
                    }}
                  >
                    {item.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <style>
        {`
          .feature-card:hover {
            transform: translateY(-8px);
            box-shadow: 0 20px 50px rgba(0,0,0,0.12) !important;
          }
        `}
      </style>
    </section>
  );
};

export default Gallery;